// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

// Mirrors `enums.PricingMode` on the BE. PER_UNIT = quantity ×
// unitPrice; FIXED = fixedPrice (quantity is informational only).
export const pricingModeSchema = caseInsensitiveEnum(['PER_UNIT', 'FIXED']);

export type PricingMode = z.infer<typeof pricingModeSchema>;

export const PRICING_MODE = {
  PER_UNIT: 'PER_UNIT',
  FIXED: 'FIXED',
} as const satisfies Record<PricingMode, PricingMode>;
